import { FunctionComponent } from "react"
import { Alert, Col, Container, Row } from "react-bootstrap"
import Button from "react-bootstrap/Button"
import { useNavigate, useParams } from "react-router-dom"
import { Agreement, RouterExtended } from "../data/models"
import useLazyQuery from "../hooks/useLazyQuery"
import useQuery from "../hooks/useQuery"

interface ICancelEndPage {}
const CancelEndPage: FunctionComponent<ICancelEndPage> = () => {
	const navigate = useNavigate()
	const params = useParams()
	const routerId = params.routerId
	const routerQuery = useQuery<void, RouterQueryResponse>(`${process.env.REACT_APP_KNIT_URL}routers?id=${routerId}`)
	const router = routerQuery.data?.routers?.[0]
	const currentAgreementUrl = `${process.env.REACT_APP_KNIT_URL}agreements/${router?.currentAgreementId}`
	const patchCurrentAgreementQuery = useLazyQuery<Partial<Agreement>, any>(currentAgreementUrl, "PATCH")
	//cancel end date function
	const cancelEnd = async () => {
		await patchCurrentAgreementQuery.query({ body: { endDate: "9999-12-31" } })
		navigate(-1)
	}
	//
	const error = patchCurrentAgreementQuery.error || routerQuery.error
	//
	if (!routerQuery.data) {
		return (
			<Container style={{ maxWidth: 500 }}>
				<h2 className="text-center mt-4">Cancel End of Internet Service</h2>
				<div className="text-center">Loading</div>
			</Container>
		)
	}
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Cancel End of Internet Service</h2>
			{error && <Alert variant={"warning"}>{error}</Alert>}
			<div className="text-center">
				Continue internet service for {router?.propertyName} {router?.unitName} with no scheduled end date?
			</div>
			<Row className="mt-4">
				<Col xs="auto">
					<Button variant="secondary" disabled={patchCurrentAgreementQuery.loading} onClick={() => navigate(-1)}>
						Cancel
					</Button>
				</Col>
				<Col></Col>
				<Col xs="auto">
					<Button variant="primary" disabled={patchCurrentAgreementQuery.loading || !!error} onClick={cancelEnd}>
						{patchCurrentAgreementQuery.loading ? "Saving" : "Confirm"}
					</Button>
				</Col>
			</Row>
		</Container>
	)
}

export default CancelEndPage

interface RouterQueryResponse {
	routers: RouterExtended[]
}
